import { gql } from '@apollo/client'

export default gql`
  fragment LibraryPostVideoCardComponent on LibraryPostVideo {
    id
    slug
    type
    title
    duration
    difficultyLevel
    image {
      url
      # blurhash
    }
    topics {
      nodes {
        id
        slug
        title
      }
    }
    description
  }
`
